import { ViewStream } from "spyne";
//import hljs from 'highlight.js';
import hljs from "highlight.js/lib/core";
import javascript from "highlight.js/lib/languages/javascript";

// Get the JavaScript language definition object.
const jsDef = javascript(hljs);

// Insert your custom mode at the beginning of the contains array

jsDef.contains.unshift({
  className: "string",
  begin: /\u200B/, // Start at backtick
  end: /`/, // End at backtick
  // No excludeBegin or excludeEnd, so the backticks are highlighted as well.ss
  // If you only want the inside highlighted, add excludeBegin: true, excludeEnd: true.
  relevance: 10, // Increase the likelihood of this mode being chosen.
  contains: [], // No internal parsing, treat everything literally as a string.
});
jsDef.contains.unshift({
  className: "number",
  begin: /\u200A/, // Start at backtick
  end: /\u200D/, // End at backtick
  // No excludeBegin or excludeEnd, so the backticks are highlighted as well.
  // If you only want the inside highlighted, add excludeBegin: true, excludeEnd: true.
  relevance: 10, // Increase the likelihood of this mode being chosen.
  contains: [], // No internal parsing, treat everything literally as a string.
});

jsDef.contains.unshift({
  className: "comment",
  begin: /<!--/, // Start at backtick
  end: /-->/, // End at backtick
  // No excludeBegin or excludeEnd, so the backticks are highlighted as well.
  // If you only want the inside highlighted, add excludeBegin: true, excludeEnd: true.
  relevance: 10, // Increase the likelihood of this mode being chosen.
  contains: [], // No internal parsing, treat everything literally as a string.
});

jsDef.contains.unshift({
  className: "comment",
  begin: /\u200A/, // Start at backtick
  end: /\*\//, // End at backtick
  // No excludeBegin or excludeEnd, so the backticks are highlighted as well.
  // If you only want the inside highlighted, add excludeBegin: true, excludeEnd: true.
  relevance: 10, // Increase the likelihood of this mode being chosen.
  contains: [], // No internal parsing, treat everything literally as a string.
});

jsDef.contains.unshift({
  className: "comment",
  begin: /\*[\s\/]/, // Start at backtick
  end: /\n/, // End at backtick
  // No excludeBegin or excludeEnd, so the backticks are highlighted as well.
  // If you only want the inside highlighted, add excludeBegin: true, excludeEnd: true.
  relevance: 10, // Increase the likelihood of this mode being chosen.
  contains: [], // No internal parsing, treat everything literally as a string.
});

/*
jsDef.contains = jsDef.contains.filter(
    mode => mode.className !== 'template-string'
);

// Insert your custom template string rule at the start
jsDef.contains.unshift({
  className: 'template-xml',
  begin: /`<div/,      // start at backtick
  end: /`/,        // end at backtick
  subLanguage: 'xml',
  excludeBegin: true, // don't highlight the backtick
  excludeEnd: true,
  relevance: 10
});

*/

// Re-register the modified JavaScript definition
hljs.registerLanguage("javascript", () => jsDef);

import { ScriptContentTraits } from "traits/script-content-traits";

export class ScriptContentView extends ViewStream {
  constructor(props = {}) {
    props.tagName = "li";
    props.class = "script-content-view";
    props.traits = [ScriptContentTraits];
    props.data.scriptType = props.data.scriptType ?? "javascript";
    props.template = require("../templates/script-content-view.tmpl.html");
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    const arr = [];
    arr.push(
      ScriptContentTraits.scriptContent$CreateActionListeners(this.props),
    );
    return arr;
  }

  broadcastEvents() {
    // return nexted array(s)
    return [];
  }

  onCodeRevealEvent(e) {
    const { scriptNum } = e.payload;
    const currentScriptNum = this.props.data.scriptNum;
    const isActiveBool = parseInt(scriptNum) === parseInt(currentScriptNum);
    //console.log("CODE REVEAL EVENT ",{scriptNum,currentScriptNum,isActiveBool,e},this.props.scriptNum);
    this.props.el$.toggleClass("active", isActiveBool);
  }

  onRendered() {
    const { scriptString } = this.props.data;

    function decodeEntities(html) {
      const el = document.createElement("textarea");
      el.innerHTML = html;
      return el.value;
    }

    this.props.code$ = this.props.el$("code");
    this.props.code$.el.innerHTML = scriptString;

    //this.props.code$.el.innerHTML = this.codeGenMain$FormatLines(decodeEntities(scriptString));;
    // this.props.code$.el.innerHTML = this.scriptContent$EscapeFormatLines(scriptString);;

    const forEachPre = (preEl) => {
      hljs.highlightElement(preEl);
    };

    //Array.from(this.props.code$.el.querySelectorAll('code')).forEach(forEachPre);

    hljs.highlightElement(this.props.code$.el);

    //hljs.highlightElement(this.props.el$("code").el);

    this.addChannel("CHANNEL_CODE_CONTAINER");
  }
}
